import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

// Choisir son mot de passe depuis le lien reçu par email.
//
// Page publique : on y arrive précisément parce qu'on ne peut pas se connecter.
// Le lien signé vaut pour un seul usage — l'enregistrer le rend caduc.

export default function ProActivation() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [compte, setCompte] = useState(null);
  const [erreur, setErreur] = useState('');
  const [mdp, setMdp] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [fait, setFait] = useState(false);

  useEffect(() => {
    fetch(`/api/pro/activation/${token}`)
      .then(async r => {
        const d = await r.json();
        if (!r.ok) throw new Error(d.error || 'Lien invalide');
        setCompte(d);
      })
      .catch(e => setErreur(e.message));
  }, [token]);

  const valider = async (e) => {
    e.preventDefault();
    setErreur('');
    if (mdp.length < 8) return setErreur('Huit caractères au minimum.');
    if (mdp !== confirmation) return setErreur('Les deux mots de passe ne sont pas identiques.');
    setEnvoi(true);
    try {
      const r = await fetch(`/api/pro/activation/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ motDePasse: mdp }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Erreur');
      setFait(true);
      setTimeout(() => navigate('/pro/login'), 2500);
    } catch (e) { setErreur(e.message); }
    finally { setEnvoi(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8 w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-7">
          <div className="w-9 h-9 bg-orange-600 rounded-lg flex items-center justify-center font-black text-white">A</div>
          <div className="leading-none">
            <span className="font-black tracking-wider text-slate-900">APEX</span>
            <span className="font-light text-orange-600 ml-1">Pro</span>
          </div>
        </div>

        {fait ? (
          <>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Mot de passe enregistré</h1>
            <p className="text-sm text-slate-500">
              Vous pouvez vous connecter avec l'identifiant <strong>{compte?.identifiant}</strong>.
              Redirection en cours…
            </p>
          </>
        ) : !compte ? (
          <>
            <h1 className="text-xl font-bold text-slate-900 mb-2">
              {erreur ? 'Lien expiré' : 'Vérification du lien…'}
            </h1>
            {erreur && (
              <>
                <p className="text-sm text-slate-500 mb-5">{erreur}</p>
                <Link to="/pro/login" className="text-sm font-semibold text-orange-700 hover:underline">
                  Retour à la connexion
                </Link>
              </>
            )}
          </>
        ) : (
          <form onSubmit={valider}>
            <h1 className="text-xl font-bold text-slate-900 mb-1">
              {compte.nouveau ? `Bienvenue${compte.prenom ? ` ${compte.prenom}` : ''}` : 'Nouveau mot de passe'}
            </h1>
            <p className="text-sm text-slate-500 mb-6">
              Choisissez votre mot de passe pour l'identifiant <strong className="text-slate-700">{compte.identifiant}</strong>.
              Personne d'autre ne le connaîtra.
            </p>

            <label htmlFor="mdp" className="block text-sm font-semibold text-slate-700 mb-2">Mot de passe</label>
            <input id="mdp" type="password" autoComplete="new-password" autoFocus
                   value={mdp} onChange={e => { setMdp(e.target.value); setErreur(''); }}
                   placeholder="8 caractères minimum"
                   className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl text-sm focus:border-orange-500 outline-none mb-4" />

            <label htmlFor="mdp2" className="block text-sm font-semibold text-slate-700 mb-2">Confirmation</label>
            <input id="mdp2" type="password" autoComplete="new-password"
                   value={confirmation} onChange={e => { setConfirmation(e.target.value); setErreur(''); }}
                   className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl text-sm focus:border-orange-500 outline-none mb-2" />

            {erreur && <p className="text-red-500 text-sm mb-3">{erreur}</p>}

            <button type="submit" disabled={envoi}
                    className="w-full mt-3 bg-orange-600 hover:bg-orange-700 disabled:bg-slate-300 text-white font-bold py-3 rounded-xl text-sm transition-colors">
              {envoi ? 'Enregistrement…' : 'Enregistrer et se connecter'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
